import { NgModule } from '@angular/core';

import { DisabledDirective } from './disabled.directive';

@NgModule({
    declarations: [DisabledDirective],
    exports: [DisabledDirective],
})
export class DisabledModule {}
